import type React from 'react';
import { useIntl } from 'react-intl';

import GenericPage from 'app/ui/components/layouts/generic-page';
import WorkoutListController from 'app/ui/components/molecules/workout-list-controller';
import Typography from 'src/app/ui/components/atoms/typography';

export const Workouts: React.FC = () => {
  const intl = useIntl();
  return (
    <GenericPage pageTitle="Workouts">
      <Typography variant="h3">{intl.formatMessage({ id: 'workoutLibrary.browse' })}</Typography>
      <WorkoutListController allowMoreFilters={true} />
    </GenericPage>
  );
};

export default Workouts;
